export default __webpack_public_path__ + "static/marketing-70c06096f07fd018324f52fd021b2b73.jpg";